class Flits {
  constructor() {
    this.items = []

    if (_state && _state.notifications) {
      this.addMultiple(_state.notifications)
    }
  }

  addMultiple(items) {
    if (items === false) {
      return
    }

    if (! Array.isArray(items)) {
      items = [ items ]
    }

    items.forEach((item, key) => {
      setTimeout(() => {
        this.addSingle(item)
      }, key * 300 + 50);
    })
  }

  addSingle(item, ttl = 5000) {
    if (typeof item == 'string') {
      item = {'level': 'error', 'message': item}
    }

    item.id = this.getUUID()
    this.items.push(item)

    setTimeout(() => {
      this.remove(item)
    }, ttl)

    return item
  }

  getUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r = Math.random() *16 | 0, v = c === 'x' ? r : (r&0x3|0x8)
      return v.toString(16)
    })
  }

  remove(item) {
      const index = this.items.findIndex(i => {
        return i.id == item.id
      })

      this.items.splice(index, 1)
  }

  success(message) {
    this.addSingle({
      level: 'success',
      message
    })
  }

  error(message) {
    this.addSingle({
      level: 'error',
      message
    })
  }

  info(message) {
    this.addSingle({
      level: 'info',
      message
    })
  }
}

const instance = new Flits

export default {
  install: function (Vue, name = '$flits') {
    Object.defineProperty(Vue.prototype, name, { value: instance })

    Vue.mixin({
      data: function () {
        return {
          'flits': instance.items,
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/front/js/plugins/flits.js